"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoHorizontal = exports.Logo = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("../../icons");
var Logo = function (_a) {
    var _b = _a.height, height = _b === void 0 ? 62 : _b, mono = _a.mono, className = _a.className;
    var width = height && Math.ceil((425 / 500) * height);
    var BpLogo1OclockLightMode = mono ? icons_1.BpLogo1OclockMono : icons_1.BpLogo1OclockColor;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(BpLogo1OclockLightMode, { width: width, height: height, className: (0, classnames_1.default)('dark-d-none', className) }), (0, jsx_runtime_1.jsx)(icons_1.BpLogo1OclockMono, { fill: "#fff", width: width, height: height, className: (0, classnames_1.default)('d-none dark-d-inline', className) })] }));
};
exports.Logo = Logo;
var LogoHorizontal = function (_a) {
    var _b = _a.height, height = _b === void 0 ? 62 : _b, mono = _a.mono, className = _a.className;
    var width = height && Math.ceil((833 / 595) * height);
    var BpLogo3OclockLightMode = mono ? icons_1.BpLogo3OclockMono : icons_1.BpLogo3OclockColor;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(BpLogo3OclockLightMode, { width: width, height: height, className: (0, classnames_1.default)('dark-d-none', className) }), (0, jsx_runtime_1.jsx)(icons_1.BpLogo3OclockMono, { fill: "#fff", width: width, height: height, className: (0, classnames_1.default)('d-none dark-d-inline', className) })] }));
};
exports.LogoHorizontal = LogoHorizontal;
